module.exports = __webpack_public_path__ + "static/media/GL_Account_Code.43e33d73.svg";